import React, { useCallback } from "react";
import { Information } from "../../../../domain/information/Information";
import { useAppDispatch } from "../../../../state/store";
import { deleteInformationAction } from "../../../../state/usecase/information/actions";
import { AdminOnlyComponents } from "../../admin/components/AdminOnlyComponents";
import { Button } from "../../common/button/Button";

export const AdminButtonArea = React.memo(function AdminButtonArea(props: Props) {
    const { information } = props;

    const dispatch = useAppDispatch();

    const handleInformationDeleteClicked = useCallback(() => {
        if (!window.confirm(`${information.title.value}を削除しますか？`)) return;
        dispatch(
            deleteInformationAction({
                informationId: information.id
            })
        );
    }, [dispatch, information]);

    return (
        <div className="button_area">
            <AdminOnlyComponents>
                <Button label={"削除"} colorReversed onClick={handleInformationDeleteClicked} />
            </AdminOnlyComponents>
        </div>
    );
});

type Props = {
    information: Information
}